var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85317 8.14715C9.0485 8.34248 9.0485 8.65917 8.85317 8.85451C8.75583 8.95184 8.62783 9.00116 8.49983 9.00116C8.37183 9.00116 8.24383 8.95251 8.1465 8.85451L4.49983 5.20782L0.853165 8.85451C0.755832 8.95184 0.627833 9.00116 0.499833 9.00116C0.371833 9.00116 0.243833 8.95251 0.1465 8.85451C-0.0488333 8.65917 -0.0488333 8.34248 0.1465 8.14715L3.79317 4.5005L0.1465 0.853857C-0.0488333 0.658523 -0.0488333 0.341833 0.1465 0.1465C0.341833 -0.0488333 0.658503 -0.0488333 0.853836 0.1465L4.5005 3.79319L8.14716 0.1465C8.34249 -0.0488333 8.65916 -0.0488333 8.8545 0.1465C9.04983 0.341833 9.04983 0.658523 8.8545 0.853857L5.20783 4.5005L8.85317 8.14715Z",
    fill: "#EF0027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.ddfd2047c38f27a1e7cd758e85f6278e.svg";
export { ForwardRef as ReactComponent };